import { render, staticRenderFns } from "./card-section.vue?vue&type=template&id=06823809&"
import script from "./card-section.vue?vue&type=script&lang=js&"
export * from "./card-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports